import styled from 'styled-components'

export const Container = styled.div<{ isCollapsed: boolean }>`
  position: relative;
  width: 100%;
  padding: 0 1rem;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  ${({ isCollapsed }) => isCollapsed && 'display: none;'}
`

export const Title = styled.p`
  font-size: 0.75rem;
  font-weight: 600;
  font-family: 'Inter';
  color: ${props => props.theme.colors.color545e6c};
  font-style: normal;
  line-height: normal;
`

export const SupportInfo = styled.div`
  position: relative;
`

export const ChannelName = styled.p`
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 0.625rem;
  font-weight: 600;
`

export const Value = styled.p`
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 0.625rem;
  font-weight: 400;
`
